import React from 'react';
import throttle from '../../includes/throttle';

export const getDocumentHeight = ()=>{
  return Math.max(document.documentElement.offsetHeight, document.body.offsetHeight);
};

export const getMaxScrollPosition = ()=>{
  return getDocumentHeight() - window.innerHeight;
};

export const getScrollPosition = ()=>{
  // not window.scrollY and window.pageYOffset are the same but the latter has better browser support
  return Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
};

//Value is returned as a ratio (1 = 100%)
export const getScrollPercentage = ()=>{
  return getScrollPosition() / getMaxScrollPosition();
};

type ScrollContexValue = {
  scroll: number;
};
const scrollContext = React.createContext<ScrollContexValue>({} as ScrollContexValue);

/* This is from https://blog.logrocket.com/developing-responsive-layouts-with-react-hooks/ */
export default function ScrollProvider({ children }: { children: React.ReactNode; }) {
  const [ scroll, setScroll ] = React.useState(0);

  const handleWindowScroll = throttle(() => {
    setScroll(getScrollPosition());
  }, 50);

  React.useEffect(() => {
    window.addEventListener('scroll', handleWindowScroll);

    setScroll(getScrollPosition());

    return () => {
      window.removeEventListener('scroll', handleWindowScroll);
    };
  }, []);

  return (
    <scrollContext.Provider value={{ scroll }}>
      {children}
    </scrollContext.Provider>
  );
}

export const useScroll = () => {
  return React.useContext(scrollContext);
};
